interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  id?: string;
}

export default function SectionTitle({ eyebrow, title, desc, align = 'left', id }: SectionTitleProps) {
  const alignClass = align === 'center' ? 'text-center items-center mx-auto' : 'text-left items-start';

  return (
    <div className={`flex max-w-3xl flex-col ${alignClass}`}>
      {eyebrow ? (
        <span className="mb-3 inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
          <span className="h-px w-6 bg-primary-400" aria-hidden="true"></span>
          {eyebrow}
        </span>
      ) : null}
      <h2 id={id} className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}